import React from "react";
import InsiderLoadable from "./InsiderLoadable";
const AsyncMobileMenu = InsiderLoadable({
    loader: () => import(/* webpackChunkName: "MobileMenu" */ "../containers/MobileMenuWithSubscription"),
    customLoader: () => <React.Fragment />
});
export default AsyncMobileMenu;
